const costAnalyticsData = state => state.costAnalyticsData;
const detailCostAnalyticsData = state => state.detailCostAnalyticsData;
const originalDetailCostAnalyticsData = state => state.originalDetailCostAnalyticsData;
const portionDetailCostAnalyticsData = state => state.portionDetailCostAnalyticsData;
const portionDetailCostAnalyticsCompareData = state => state.portionDetailCostAnalyticsCompareData;
const filterSettings = state => state.filterSettings
const filterOptions = state => state.filterOptions;
const userFilters = state => state.userFilters;
const visibleColumnFields = state => state.visibleColumnFields;
const isCloseQuickFilterDropdown = state => state.isCloseQuickFilterDropdown;
const isInitialLoad = state => state.isInitialLoad;
const isMonthly = state => state.isMonthly;
const isOthers = state => state.isOthers;

export default {
  portionDetailCostAnalyticsData,
  detailCostAnalyticsData,
  originalDetailCostAnalyticsData,
  costAnalyticsData,
  filterSettings,
  filterOptions,
  userFilters,
  visibleColumnFields,
  portionDetailCostAnalyticsCompareData,
  isCloseQuickFilterDropdown,
  isInitialLoad,
  isMonthly,
  isOthers
};



// WEBPACK FOOTER //
// ./src/store/modules/cost-analytics/getters.js